import moment from 'moment';

export const fromNow = date => moment(date).fromNow();
